import React from 'react'

import Chip from '../../../../../../../components/Chip'

import { getFormattedAdStatusProps } from '../helper'

const AdStatusChip = ({ ad }) => {
  if (!ad?.status && ad?.effective_status !== 'disapproved') {
    return null
  }

  const { status, color } = getFormattedAdStatusProps(ad)

  return <Chip text={status} color={color} />
}

export default AdStatusChip
